import { render, staticRenderFns } from "./today.vue?vue&type=template&id=5f5e517c&scoped=true&"
import script from "./today.vue?vue&type=script&lang=js&"
export * from "./today.vue?vue&type=script&lang=js&"
import style0 from "./today.vue?vue&type=style&index=0&id=5f5e517c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e517c",
  null
  
)

export default component.exports